import { Capacitor } from '@capacitor/core';

export const isNative = () => Capacitor.isNativePlatform();
export const isIOS = () => Capacitor.getPlatform() === 'ios';
export const isAndroid = () => Capacitor.getPlatform() === 'android';
export const isWeb = () => Capacitor.getPlatform() === 'web';

// Cadence is IAP-only — there is no web payment provider. Purchases are
// possible on iOS only; the web app shows "get the iOS app" instead.
export const canPurchase = () => isIOS();
